const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 官方数型内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_number.html
 * @author Caesar Liu
 * @date 2020-11-20 14:58
 */
module.exports = [
  buildConfig('abs', {
    documentation: '获取数字的绝对值\ne.g: ${-5?abs}\n如果 x 是 -5，将得到5'
  }),
  buildConfig('is_infinite', {
    documentation: '辨别数字是否是无限浮点数，返回布尔值true或false'
  }),
  buildConfig('is_nan', {
    documentation: '辨别字符串是否为数字，返回布尔值true或false'
  }),
  buildConfig('lower_abc', {
    documentation: '将整数1,2,3...转为a,b,c...，到递增达到z时，那么会继续转换为aa,ab,ac...'
  }),
  buildConfig('round', {
    documentation: '返回数字四舍五入后的结果'
  }),
  buildConfig('floor', {
    documentation: '返回数字向下取整的结果'
  }),
  buildConfig('ceiling', {
    documentation: '返回数字向上取整的结果'
  }),
  // buildConfig('string.currency', {
  //   documentation: [
  //     '将数字转换为金额格式',
  //     'e.g: ${42?string.currency}',
  //     '返回$42.00'
  //   ].join('\n')
  // }),
  buildConfig('string.percent', {
    documentation: [
      '将数字转换为百分比',
      'e.g: ${0.42?string.percent}',
      '返回42%'
    ].join('\n')
  }),
  buildConfig('upper_abc', {
    documentation: '将整数1,2,3...转为A,B,C...，到递增达到Z时，那么会继续转换为AA,AB,AC...'
  })
]
